import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { EmpresaProvider } from './context/EmpresaContext';
import { PermisosProvider } from './context/PermisosContext';
import RutaProtegida from './components/RutaProtegida';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Planes from './pages/Planes';
import Cartera from './pages/Cartera';
import Dinero from './pages/Dinero';
import Ventas from './pages/Ventas';
import Cotizaciones from './pages/Cotizaciones';
import PedidosWeb from './pages/PedidosWeb';
import Reportes from './pages/Reportes';
import Configuracion from './pages/Configuracion';
import Usuarios from './pages/Usuarios';
import ProveedoresRed from './pages/ProveedoresRed';
import Revendedores from './pages/Revendedores';
import Catalogo from './pages/Catalogo';
import RevisarCostosPDF from './pages/RevisarCostosPDF';
import CompararProveedores from './pages/CompararProveedores';
import Vendedores from './pages/Vendedores';
import Tickets from './pages/Tickets';
import Agenda from './pages/Agenda';
import Mikrotik from './pages/Mikrotik';
import Red from './pages/Red';
import Whatsapp from './pages/Whatsapp';
import Ayuda from './pages/Ayuda';
import Caucared from './pages/caucared/Caucared';

export default function App() {
  return (
    <AuthProvider>
      <EmpresaProvider>
        <PermisosProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login"           element={<Login />} />
              <Route path="/dashboard"       element={<RutaProtegida><Dashboard /></RutaProtegida>} />
              <Route path="/clientes"        element={<RutaProtegida><Clientes /></RutaProtegida>} />
              <Route path="/planes"          element={<RutaProtegida><Planes /></RutaProtegida>} />
              <Route path="/cartera"         element={<RutaProtegida><Cartera /></RutaProtegida>} />
              <Route path="/revendedores"    element={<RutaProtegida><Revendedores /></RutaProtegida>} />
              {/* Rutas de un módulo Red que ya no está. Llevan al panel para no dejar a
                  nadie en una página en blanco si tenía un enlace guardado. */}
              <Route path="/equipos-red"     element={<Navigate to="/dashboard" replace />} />
              <Route path="/red"             element={<RutaProtegida><Red /></RutaProtegida>} />
              <Route path="/catalogo"         element={<RutaProtegida><Catalogo /></RutaProtegida>} />
              <Route path="/catalogo/costos"  element={<RutaProtegida><RevisarCostosPDF /></RutaProtegida>} />
              <Route path="/catalogo/comparar" element={<RutaProtegida><CompararProveedores /></RutaProtegida>} />
              <Route path="/vendedores"      element={<RutaProtegida><Vendedores /></RutaProtegida>} />
              <Route path="/dinero"          element={<RutaProtegida><Dinero /></RutaProtegida>} />
              {/* Ingresos/Egresos y Caja diaria se fusionaron en Dinero. Los ingresos ya
                  no se escriben: se calculan de los cobros y las ventas. Se conservan las
                  rutas viejas para no dejar en blanco un enlace guardado. */}
              <Route path="/transacciones"   element={<Navigate to="/dinero" replace />} />
              <Route path="/caja"            element={<Navigate to="/dinero" replace />} />
              <Route path="/ventas"          element={<RutaProtegida><Ventas /></RutaProtegida>} />
              <Route path="/pedidos-web"    element={<RutaProtegida><PedidosWeb /></RutaProtegida>} />
              <Route path="/cotizaciones"    element={<RutaProtegida><Cotizaciones /></RutaProtegida>} />
              <Route path="/reportes"        element={<RutaProtegida><Reportes /></RutaProtegida>} />
              <Route path="/configuracion"   element={<RutaProtegida><Configuracion /></RutaProtegida>} />
              <Route path="/usuarios"        element={<RutaProtegida><Usuarios /></RutaProtegida>} />
              <Route path="/proveedores-red" element={<RutaProtegida><ProveedoresRed /></RutaProtegida>} />
              <Route path="/tickets"         element={<RutaProtegida><Tickets /></RutaProtegida>} />
              <Route path="/agenda"          element={<RutaProtegida><Agenda /></RutaProtegida>} />
              <Route path="/equipos"         element={<Navigate to="/dashboard" replace />} />
              <Route path="/mikrotik"        element={<RutaProtegida><Mikrotik /></RutaProtegida>} />
              <Route path="/whatsapp"        element={<RutaProtegida><Whatsapp /></RutaProtegida>} />
              {/* CAUCARED, la marca hermana: su facturación aparte (tablas cau_ en el servidor) */}
              <Route path="/caucared"          element={<Navigate to="/caucared/cotizaciones" replace />} />
              <Route path="/caucared/:seccion" element={<RutaProtegida><Caucared /></RutaProtegida>} />
              <Route path="/ayuda"         element={<RutaProtegida><Ayuda /></RutaProtegida>} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </PermisosProvider>
      </EmpresaProvider>
    </AuthProvider>
  );
}
